import React from 'react'
import { Link } from 'react-router-dom'
import { Dropdown, Icon, Menu, Button } from 'antd'

import './create-account.scss'

export default ({providers}) =>{
  return (
    <Dropdown overlay={menu(providers)} overlayClassName='create-account-dropdown-wrapper'>
      <div className='create-account-dropdown'>
      {/* <div className='create-account-dropdown round-corner'> */}
        <Button>
          Add Your Cloud Account <Icon type='down' />
        </Button>
      </div>
    </Dropdown>
  )
}

const menu =(providers)=> (
  <Menu className='create-account-menu'>
    {providers.map((provider, index) => (
      <Menu.Item key={index}>
        <Link to={'/addProvider/' + provider.name}>
          <img src={provider.img} style={provider.style} alt='' />
          <Icon type='plus-circle-o' />
        </Link>
      </Menu.Item>
    ))}
  </Menu>
)
